import { render, staticRenderFns } from "./NamespaceSidebar.vue?vue&type=template&id=2c2b78e1&"
import script from "./NamespaceSidebar.vue?vue&type=script&lang=js&"
export * from "./NamespaceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NamespaceSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports